// @flow
import * as React from 'react'
import ReactToggle from 'react-toggle'

export type Props = {
  onChange: (event: SyntheticInputEvent<HTMLInputElement>) => mixed,
  iconChecked?: React.Node,
  iconUnchecked?: React.Node,
  primary?: boolean,
  primaryIdle?: boolean,
  value: boolean,
  disabled?: boolean,
}

function Toggle({
  onChange,
  iconChecked,
  iconUnchecked,
  primary,
  primaryIdle,
  value,
  disabled,
  ...rest
}: Props): React.Node {
  return (
    <ReactToggle
      {...rest}
      checked={value}
      className={`${primary ? 'primary' : ''}${
        primaryIdle ? 'primary-idle' : ''
      }`}
      disabled={disabled}
      icons={{
        checked: iconChecked ?? null,
        unchecked: iconUnchecked ?? null,
      }}
      onChange={onChange}
    />
  )
}

export default Toggle
